<div dbCustomScrollbar class="db-email-preferences">
  <div class="db-email-preferences__panel">
    <div><a class="db-email-preferences__logo" [routerLink]="['/websites']"><i class="db-icon db-icon-tw-logo"></i></a></div>
    <ng-container *ngIf="unsubscribedFromAll">
      <div class="db-email-preferences__header">{{'text_emailPreferences.unsubscribedHeader' | dbText}}</div>
      <div class="db-email-preferences__description" [innerHTML]="'text_emailPreferences.unsubscribedDescription' | dbText"></div>
    </ng-container>
  </div>
  <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
</div>
